const nonAqTeamIds = [
  1283965, 1282363, 1282001, 1286592, 1282002, 1281902, 1282983, 1282354,
  1281975, 1282042, 1282208, 1282766, 1282033, 1282345, 1303973,
];

export default nonAqTeamIds;
